import { type IInstructionFeedbackActivity } from "@/interfaces/api/instruction-feedback-activity.interface"
import { InstructionFeedbackActivityProduct } from "@/models/instruction-feedback-activity-product"
import { InstructionFeedbackActivityType } from "@/models/tenant_settings/instruction-feedback-activity-type.model"
import { ModelFactory } from "@/factories/model-factory"
import { BaseModelWithFiles } from "@/models/base-with-files.model"
import type { Moment } from "moment"
import { Location } from "@/models/location.model"
import type { ILocation } from "@/interfaces/api/location.interface.ts"

export class InstructionFeedbackActivity
  extends BaseModelWithFiles
  implements IInstructionFeedbackActivity
{
  public static className = "InstructionFeedbackActivity"
  public static verboseName = "Instruction Feedback Activity"

  instructionFeedback: string
  workPeriod: string
  instructionFeedbackActivityProducts: InstructionFeedbackActivityProduct[]
  location: Location

  type: InstructionFeedbackActivityType
  timeStart: Moment | undefined
  timeEnd: Moment | undefined
  customLocationText: string | undefined
  body: string | undefined

  constructor(instructionFeedbackActivity: IInstructionFeedbackActivity, managed = false) {
    super(instructionFeedbackActivity, managed)

    this.instructionFeedback = instructionFeedbackActivity.instructionFeedback
    this.workPeriod = instructionFeedbackActivity.workPeriod
    this.instructionFeedbackActivityProducts = ModelFactory.childModels(
      InstructionFeedbackActivityProduct,
      instructionFeedbackActivity.instructionFeedbackActivityProducts,
      managed
    )
    this.location = ModelFactory.childModel(
      Location,
      instructionFeedbackActivity.location
        ? instructionFeedbackActivity.location
        : new Location({} as ILocation),
      managed
    )

    this.type = ModelFactory.childModel(
      InstructionFeedbackActivityType,
      instructionFeedbackActivity.type,
      managed
    )
    this.timeStart = instructionFeedbackActivity.timeStart
    this.timeEnd = instructionFeedbackActivity.timeEnd
    this.customLocationText = instructionFeedbackActivity.customLocationText
    this.body = instructionFeedbackActivity.body
  }

  public isComplete(): boolean {
    return !!this.type && !!this.timeStart && !!this.timeEnd && !!this.getLocationText()
  }

  public getTypeString(): string {
    return this.type?.name ?? ""
  }

  public getLocationText(): string | undefined {
    if (this.location.address && this.location.address.length > 0) {
      return this.location.address
    }
    return this.customLocationText
  }
}
